module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-metodou-derma-k_16_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/vyhlazeni-vrasek-metodou-derma-k_16_before.jpg
// module id = 1242
// module chunks = 0